import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { showActionErrorFromUnknown } from "@/lib/feedback";
import { communicationChannelsService } from "@/services/communicationChannelsService";

export function VerifyCodePage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const hasOnboarded = useRef(false);

  useEffect(() => {
    if (hasOnboarded.current) return;
    hasOnboarded.current = true;

    const code = searchParams.get("code");
    const state = searchParams.get("state");

    if (!code) {
      toast.error("Failed to connect WhatsApp: missing code parameter from Meta.");
      navigate("/integrations");
      return;
    }

    if (!state) {
      toast.error("Failed to connect WhatsApp: missing state parameter.");
      navigate("/integrations");
      return;
    }

    let entityId = "";
    let entityType = "";
    let legalEntityId = "";

    try {
      const decodedState = JSON.parse(atob(decodeURIComponent(state)));
      entityId = decodedState.entityId;
      entityType = decodedState.entityType;
      legalEntityId = decodedState.legalEntityId ?? "";
    } catch (e) {
      console.error("Failed to decode state parameter", e);
      toast.error("Failed to connect WhatsApp: invalid state parameter.");
      navigate("/integrations");
      return;
    }

    const branchId = entityType === 'BR' ? entityId : undefined;
    
    communicationChannelsService
      .onboardWhatsapp(code, legalEntityId, branchId)
      .then(() => {
        toast.success("WhatsApp Business Account connected successfully!");
        navigate(entityType === 'BR' ? "/profile" : "/integrations");
      })
      .catch((error) => {
        console.error("WhatsApp Onboarding failed:", error);
        showActionErrorFromUnknown(
          error,
          "Failed to complete WhatsApp onboarding. Please try again.",
          { title: "WhatsApp onboarding failed" },
        );
        navigate(entityType === 'BR' ? "/profile" : "/integrations");
      });
  }, [searchParams, navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-4">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-bridge-accent"></div>
      <p className="text-slate-600 font-medium">Finishing WhatsApp setup...</p>
    </div>
  );
}
